export default { sha: 'ca42043c3a1edd1a3009f82fc0a935835d528993', buildNumber: 'undefined' }
